import React from 'react';
import classNames from 'classnames';
import ALink from 'tradera/components/alink/alink';
import ArrowRightIcon from '@tradera/blueprint/theme/icons2/arrow-right.svg?jsx';
import { Button } from 'tradera/components/atoms/button/button';

import css from './more-results-card.module.scss';

export const MoreResultsCard = (props) => {
    const { label, href, onClick, ...rest } = props;
    return (
        <div
            className={classNames(
                'item-card-new m-0 justify-content-center',
                css.wrapper
            )}
            {...rest}>
            <ALink
                className={classNames(
                    'd-flex flex-column align-items-center',
                    css.link
                )}
                href={href}
                onClick={onClick}
                useLink={false} // Use 'inSPA' when mytradera-page can be navigated to without a hard reload
            >
                <Button theme="primary" variant="outline" round size="md">
                    <ArrowRightIcon className="icon icon-md" />
                </Button>
                <div className="pt-2">{label}</div>
            </ALink>
        </div>
    );
};
